/**
 * @generated SignedSource<<914560e1b0c92b075ec267e3f2578eac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DesktopLaunchPageLoginTicketMutation$variables = {
  path: string;
};
export type DesktopLaunchPageLoginTicketMutation$data = {
  readonly generateLoginTicket: {
    readonly ticket: string;
  } | null;
};
export type DesktopLaunchPageLoginTicketMutation = {
  response: DesktopLaunchPageLoginTicketMutation$data;
  variables: DesktopLaunchPageLoginTicketMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "path"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "path",
        "variableName": "path"
      }
    ],
    "concreteType": "GenerateLoginTicket",
    "kind": "LinkedField",
    "name": "generateLoginTicket",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ticket",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DesktopLaunchPageLoginTicketMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DesktopLaunchPageLoginTicketMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ef13abc2100749bfbcdb581ca2f969dc",
    "id": null,
    "metadata": {},
    "name": "DesktopLaunchPageLoginTicketMutation",
    "operationKind": "mutation",
    "text": "mutation DesktopLaunchPageLoginTicketMutation(\n  $path: String!\n) {\n  generateLoginTicket(path: $path) {\n    ticket\n  }\n}\n"
  }
};
})();

(node as any).hash = "45e7246cf706f93200a87d82f192098e";

export default node;
